var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCalender(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66669 15.8333C1.66669 17.25 2.75002 18.3333 4.16669 18.3333H15.8334C17.25 18.3333 18.3334 17.25 18.3334 15.8333V9.16663H1.66669V15.8333ZM15.8334 3.33329H14.1667V2.49996C14.1667 1.99996 13.8334 1.66663 13.3334 1.66663C12.8334 1.66663 12.5 1.99996 12.5 2.49996V3.33329H7.50002V2.49996C7.50002 1.99996 7.16669 1.66663 6.66669 1.66663C6.16669 1.66663 5.83335 1.99996 5.83335 2.49996V3.33329H4.16669C2.75002 3.33329 1.66669 4.41663 1.66669 5.83329V7.49996H18.3334V5.83329C18.3334 4.41663 17.25 3.33329 15.8334 3.33329Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalender);
export default __webpack_public_path__ + "static/media/icon__calender.c5148304e292d38f90db6d2a49d5f76e.svg";
export { ForwardRef as ReactComponent };